import Configuration from './configuration';

class APIManager {
	static async get(method) {
		const url = `${Configuration.ENDPOINT_URL}${method}/es_ES.json`;
		let response = await fetch(url);
		let json = await response.json();
		if (json.code === '200') {
			return { data: json.data };
		} else {
			throw new Error({ code: json.code, message: `Ha ocurrido un error al obtener la infomación de ${url}` });
		}
	}

	static post(method, data) {
		const dataArray = {};

		for (let item of data) {
			if (item.type !== 'submit') {
				dataArray[item.name] = item.value;
			}
		}

		const url = `${Configuration.ENDPOINT_URL}${method}.json`;

		const ajax_request = new XMLHttpRequest();
		ajax_request.open('POST', url, true);
		ajax_request.setRequestHeader('Content-type', 'application/json');
		ajax_request.send(JSON.stringify(dataArray));

		return (ajax_request.onreadystatechange = function() {
			if (ajax_request.readyState === 4) {
				const json = JSON.parse(ajax_request.response);
				if (json.code === '200') {
					let form = document.querySelector('.form .form__container');
					form.innerHTML = 'Su solicitud de inscripción se ha enviado correctamente';
				} else {
					alert(`Ha ocurrido un error: ${json.message}`);
				}
			}
		});
	}

	/**
     * Gets SiteProperties ad the actualPage
     */
	static async getInitial(actualPage = 'home') {
		let urls = Configuration.urls('site-properties', actualPage);
		let data = await Promise.all(
			Object.keys(urls).map((value) => {
				return this.get(urls[value]);
			})
		);
		let result = {};

		Object.keys(urls).forEach((value, key) => (result[value] = data[key]));

		return result;
	}

	static async getAll() {
		let urls = Configuration.urls();
		let data = await Promise.all(
			Object.keys(urls).map((value) => {
				return this.get(urls[value]);
			})
		);
		let result = {};

		Object.keys(urls).forEach((value, key) => (result[value] = data[key]));

		return result;
	}
}

export default APIManager;
